import { useEffect, useMemo, useRef, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useGetContentQuery } from "../../redux/Apis/Content";
import { useGetAllCreatorReviewsQuery } from "../../redux/Apis/CreatorReviews";
import { useGetAllLearnerReviewsQuery } from "../../redux/Apis/LearnerReviews";
import CreatorReviewCard from "../cards/ReviewCard/CreatorReviewCard";
import OwlCarousel from "../carousel";

const CorporateSection = () => {
  const carouselRef = useRef();
  const lang = useSelector((state) => state.language.lang);
  const [expandedItems, setExpandedItems] = useState({});
  const {
    data: corporate,
    isLoading: isCorporateLoading,
    refetch: refetchCorporate,
  } = useGetContentQuery({ search: "corporate-solutions", lang });
  const { data: creatorReviews, isLoading: isCreatorReviewsLoading } =
    useGetAllCreatorReviewsQuery({ lang: lang });
  const { data: learnerReviews, isLoading: isLearnerReviewsLoading } =
    useGetAllLearnerReviewsQuery({ lang: lang });

  useEffect(() => {
    refetchCorporate();
  }, []);

  const mergedReviews = useMemo(() => {
    const creatorData =
      creatorReviews?.data?.map((item) => ({
        ...item,
        reviewType: "creator",
      })) || [];

    const learnerData =
      learnerReviews?.data?.map((item) => ({
        ...item,
        reviewType: "learner",
      })) || [];

    return [...creatorData, ...learnerData];
  }, [creatorReviews, learnerReviews]);

  const toggleItem = (id) => {
    const currentIndex = carouselRef.current?.getCurrentIndex?.();

    setExpandedItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));

    requestAnimationFrame(() => {
      setTimeout(() => {
        if (typeof currentIndex === "number") {
          carouselRef.current?.goTo(currentIndex);
        }
      }, 0);
    });
  };

  if (!corporate?.data?.sections?.length) return null;

  return (
    <>
      {corporate?.data?.sections?.map((item, index) => (
        <section key={index} className="success-stories pb-sm-5 pb-4">
          {isCorporateLoading || isCreatorReviewsLoading ? (
            <div className="d-flex justify-content-center">
              <Spinner style={{ color: "var(--primaryColor)" }} />
            </div>
          ) : (
            <div className="container">
              <div className="row align-items-center justify-content-between">
                <div className="col-xxl-5 col-xl-6 col-lg-7 col-md-9 order-lg-1 order-2">
                  <h2 className="text-uppercase">{item?.title}</h2>
                  <OwlCarousel
                    ref={carouselRef}
                    className="testimonial-carousel"
                    options={{
                      margin: 20,
                      loop: false,
                      nav: true,
                      dots: false,
                      lazyLoad: true,
                      autoplay: false,
                      smartSpeed: 500,
                      navText: [
                        '<i class="fas fa-angle-left"></i>',
                        '<i class="fas fa-angle-right"></i>',
                      ],
                      responsive: {
                        0: { items: 1 },
                        768: { items: 1 },
                        992: { items: 1 },
                      },
                    }}
                  >
                    {mergedReviews?.map((item) => (
                      <CreatorReviewCard
                        key={item._id}
                        item={item}
                        isExpanded={!!expandedItems[item._id]}
                        toggle={toggleItem}
                      />
                    ))}
                  </OwlCarousel>
                </div>
                <div className="col-lg-5 mx-auto my-3 order-lg-2 order-1">
                  <a href={item?.url} target="_blank" rel="noopener noreferrer">
                    <img
                      src={`${process.env.REACT_APP_S3_BASE_URL}${item?.content}`}
                      className="img-fluid w-100"
                      style={{ borderRadius: "1rem" }}
                      alt={item?.title}
                    />
                  </a>
                </div>
              </div>
            </div>
          )}
        </section>
      ))}
    </>
  );
};

export default CorporateSection;
